import RequestService from '../services/utils/request-service'

export default {
  install (Vue) {
    Vue.prototype.$fetch = new RequestService(new Vue())
  },
}
